import { CaseInsensitiveMap } from "@multiweb/types/multiweb";
import { OWManager } from "OW.Remoting/Remoting/OWManager";
import { IFirmlyDisabledRights } from "OW.Remoting/Remoting/Rights";

/** Kešuje dotazy na firmlyDisabledRights na rozhraní serveru */
export class FirmlyDisabledRights {
    private static readonly _cache: CaseInsensitiveMap<Promise<IFirmlyDisabledRights>> = new CaseInsensitiveMap();

    /** Pro zadanou třídu, vrací pevně zakázaná práva. */
    public static async get(className: string): Promise<IFirmlyDisabledRights> {
        if (!this._cache.has(className)) {
            const promise = OWManager.firmlyDisabledRights(className);
            this._cache.set(className, promise);
        }
        return await this._cache.get(className);
    }

    /** Smaže cache vyhodnocených práv. */
    public static clearCache(): void {
        this._cache.clear();
    }
}
